import { FormContainer } from "./FormContainer";
import * as React from "react";

import { convertKenticoRawFormToJSONFormAsData } from "../kentico/KenticoRawFormToJSONForm";
import { FormConfigHelpers } from "../formcontrols/helpers/FormConfigHelpers";
import { KenticoformHelpers } from "./helpers/KenticoFormHelpers";
import { IFormConfig } from "../interfaces/FormConfig";
import { MijnFNVPageContext } from "../presentational/pages/helpers/MijnFNVPageContext";
import { connect } from "react-redux";
import { LogoutPopup } from '../presentational/LogoutPopup';
import { getAllUrlParams } from '../../jslibs/urlparams';
import { RefObject } from "react";
import WidgetForm from "../forms/WidgetForm";

export interface KenticoFormProps {
  sidebarRef: RefObject<HTMLDivElement>;
  stepsContainerRef: RefObject<HTMLDivElement>;
  formConfig: IFormConfig;
  editMode?: boolean;
  formDefinitions?: any;
  additionalCssClass: string;
  withLinkToFormPage?: boolean;
  formName: string;
  formType: string;
  formTitle?: string;
  pageType: string;
  nextLink?: string;
  linkText?: string;
  summaryIntro?: string;
  layoutType?: string;
  onSuccessPopupMessage?: string;
  onSuccessPopupMessageVisualCheck?: string;
  onSuccessPopupDescription?: string;
  initialData?: any;
  onSubmitSuccessButton1Link?: string;
  onSubmitSuccessButton1LinkText?: string;
  onSubmitSuccessButton2Link?: string;
  onSubmitSuccessButton2LinkText?: string;
  includeCurrentPageAsBackAndSubmitUrl? : boolean;
  backTitleForCurrentPageBackLink? : string;

  renderFormTriggers?: any;
  onOverrideGetFormValues?: any;

  errorMessageTitle?: string;
  errorMessageDescription?: string;
  errorMessagePhoneNumberInfo?: string;
  errorMessagePhoneNumber?: string;
  errorMessageEmailInfo?: string;
  errorMessageEmail?: string;
  errorMessageButtonText?: string;

  onFieldChange?: (formName: string, fieldName : string, value : any) => void;
  onPopupOkClick?: () => Promise<any>;
}

interface KenticoFormState {
  formDefinitions: any;
  formConfig: IFormConfig;
}

const mapStateToProps = (state: any) => {
  return {
    renderFormTriggers: state.renderFormTriggers
  };
};

class KenticoFormContained extends React.Component<
  KenticoFormProps,
  KenticoFormState
> {
  constructor(props: KenticoFormProps) {
    super(props);

    if (props.formDefinitions !== undefined) {
      let initalFormConfig = props.formConfig || {};
      
      let isEmptyFormConfig = true;
      for (var property in initalFormConfig) {
        if (initalFormConfig.hasOwnProperty(property)) {
            isEmptyFormConfig = false;
        }
      }

      if (isEmptyFormConfig) {
        initalFormConfig = FormConfigHelpers.getDefaultFormConfig(this.props.formName, this.props.formTitle);
      }

      let formConfig: IFormConfig = FormConfigHelpers.getMergedFormConfig(
        initalFormConfig as IFormConfig
      );
            
      let formDefinitions = convertKenticoRawFormToJSONFormAsData(
        props.formDefinitions,
        formConfig,
        props.formName
      );

      formDefinitions = KenticoformHelpers.generateSummaryStep(
        this,
        formDefinitions,
        formConfig
      );

      this.state = {
        formDefinitions: formDefinitions,
        formConfig: formConfig
      };
    } else {
      this.state = {
        formDefinitions: undefined,
        formConfig: undefined
      };
    }
  }
  
  render() {
    if (
      this.state.formDefinitions === undefined ||
      this.state.formConfig === undefined
    ) {
      return null;
    }

    const urlParams = getAllUrlParams();
    if (urlParams.state === "auto-logout") {
        return <LogoutPopup 
          title={this.props.formConfig.LogoutPopupTitle}
          description={this.props.formConfig.LogoutPopupDescription}
        ></LogoutPopup>;
    }

    let formConfig = this.state.formConfig;
    if (formConfig.renderFormTrigger) {
      if (
        !this.props.renderFormTriggers.triggers[formConfig.renderFormTrigger]
      ) {
        return <></>;
      }
    }

    const formproperties = {
      editMode: this.props.editMode !== undefined ? this.props.editMode : true,
      layoutType : this.props.layoutType,
      formConfig: this.state.formConfig,
      formDefinitions: this.state.formDefinitions,
      additionalCssClass: this.props.additionalCssClass,
      withLinkToFormPage: this.props.withLinkToFormPage,
      formName: this.props.formName,
      formType: this.props.formType,
      pageType: this.props.pageType,
      nextLink: this.props.nextLink,
      linkText: this.props.linkText,
      includeCurrentPageAsBackAndSubmitUrl: this.props.includeCurrentPageAsBackAndSubmitUrl,
      backTitleForCurrentPageBackLink: this.props.backTitleForCurrentPageBackLink,
      summaryIntro: this.props.summaryIntro,
      onSuccessPopupMessage: this.props.onSuccessPopupMessage,
      onSuccessPopupMessageVisualCheck: this.props.onSuccessPopupMessageVisualCheck,
      onSuccessPopupDescription: this.props.onSuccessPopupDescription,
      initialData: this.props.initialData,
      onSubmitSuccessButton1Link: this.props.onSubmitSuccessButton1Link,
      onSubmitSuccessButton1LinkText: this.props.onSubmitSuccessButton1LinkText,
      onSubmitSuccessButton2Link: this.props.onSubmitSuccessButton2Link,
      onSubmitSuccessButton2LinkText: this.props.onSubmitSuccessButton2LinkText,
      onOverrideGetFormValues: this.props.onOverrideGetFormValues,
      errorMessageTitle : this.props.errorMessageTitle,
      errorMessageDescription : this.props.errorMessageDescription,
      errorMessagePhoneNumberInfo : this.props.errorMessagePhoneNumberInfo,
      errorMessagePhoneNumber : this.props.errorMessagePhoneNumber,
      errorMessageEmailInfo : this.props.errorMessageEmailInfo,
      errorMessageEmail : this.props.errorMessageEmail,
      errorMessageButtonText : this.props.errorMessageButtonText,
      onFieldChange: this.props.onFieldChange,
      onPopupOkClick: this.props.onPopupOkClick
    };

    let formContent;

    switch (formproperties.formType) {
      case 'FormV2':
        formContent =  <WidgetForm props={formproperties} formDefinitions={this.props.formDefinitions} sidebarRef={this.props.sidebarRef} stepsContainerRef={this.props.stepsContainerRef}/>
        break;
      default:
        formContent = <FormContainer {...formproperties} />
        break;
    }

    return (
      <>
        {formContent}
      </>
    );
  }
}

KenticoFormContained.contextType = MijnFNVPageContext;

export const KenticoFormContainer = connect(mapStateToProps)(
  KenticoFormContained
);
